import { render } from "./MemberDetailsPage.vue?vue&type=template&id=700ed628"
import script from "./MemberDetailsPage.vue?vue&type=script&lang=js"
export * from "./MemberDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__